import {HttpErrorResponse} from '@angular/common/http';

/**
 * Übersetzt den HTTP-Status des Backends in eine konkrete Meldung.
 *
 * Vorher stand hinter jedem Fehler dieselbe generische Zeile -- 403 (Berechtigung), 400
 * (verknüpfte Datei ist kein IFC), 404 (Datei/Projekt/Ordner nicht gefunden) und 500 waren
 * nicht unterscheidbar, weder für Nutzer noch im Support.
 */
export function coordinationModelErrorMessage(err: HttpErrorResponse): string {
  switch (err.status) {
    case 400:
      return 'Koordinationsmodell konnte nicht erstellt werden: mindestens eine ausgewählte Datei ist keine IFC-Datei.';
    case 403:
      return 'Koordinationsmodell konnte nicht erstellt werden: fehlende Berechtigung für dieses Projekt.';
    case 404:
      return 'Koordinationsmodell konnte nicht erstellt werden: mindestens eine ausgewählte Datei gehört nicht (mehr) zu diesem Projekt. Bitte die Dateiliste neu laden.';
    case 409:
      return 'Koordinationsmodell konnte nicht erstellt werden: der Name ist in diesem Ordner bereits vergeben.';
    case 0:
      return 'Koordinationsmodell konnte nicht erstellt werden: keine Verbindung zum Server.';
    default:
      return `Koordinationsmodell konnte nicht erstellt werden (Fehler ${err.status}). Bitte erneut versuchen.`;
  }
}

/**
 * Viewer-Route eines gespeicherten Koordinationsmodells.
 *
 * Adressiert wird das Koordinationsmodell selbst, nicht seine erste verknuepfte Datei plus
 * `?coordination=`: nur so bleibt der Link stabil, wenn die Verknuepfungen spaeter bearbeitet
 * werden, und der Viewer kann den Namen des Modells anzeigen. Aufgeloest werden die verknuepften
 * IFC-Dateien im FileViewerComponent.
 */
export function coordinationModelPath(projectId: number | string, coordinationModelId: string): string {
  return `/projects/${projectId}/files/${coordinationModelId}`;
}
